import { render, staticRenderFns } from "./TiltCard2.vue?vue&type=template&id=3642cc1a&scoped=true&lang=pug"
import script from "./TiltCard2.vue?vue&type=script&lang=js"
export * from "./TiltCard2.vue?vue&type=script&lang=js"
import style0 from "./TiltCard2.vue?vue&type=style&index=0&id=3642cc1a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3642cc1a",
  null
  
)

export default component.exports